import { DEFAULT_MIN_YEAR } from '@Components/DatePicker/DatePickerButton/DatePickerConstants';

export const CONDITION_OPTIONS = ['UTM Parameter', 'Device', 'Cookie', 'Browser', 'OS'];
export const CONDITION_RULE = ['Contains', 'Equals', 'Excludes'];
export const CONDITION_RULE_SINGLE = ['Equals', 'Excludes'];
export const UTM_OPERATION = ['Add', 'Replace', 'Delete', 'Override'];
export const COOKIE_OPERATION = ['Create', 'Replace', 'Delete'];

export const CONDITION_VALUES = {
  Device: ['Mobile', 'Tablet', 'Desktop'],
  Browser: ['Chrome', 'Safari', 'Firefox', 'Opera', 'Microsoft Edge'],
  OS: ['iOS', 'MacOS', 'Android', 'Windows', 'Linux']
};

export const TIMEZONE_MAP: Record<string, string> = {
  'Central / Chicago': 'America/Chicago',
  'Eastern / New York': 'America/New_York',
  'Mountain / Denver': 'America/Denver',
  'Pacific / Los Angeles': 'America/Los_Angeles',
  UTC: 'UTC'
};
export const TIMEZONE_MAP_KEYS = Object.keys(TIMEZONE_MAP);

export const MILLISECONDS_IN_HOUR = 3600000;
export const DATE_FORMAT = 'yyyy-MM-dd';

// A rule's timeframe schedule doesn't need to look further than a decade out.
export const TIMEFRAME_MIN_YEAR = DEFAULT_MIN_YEAR;
export const TIMEFRAME_MAX_YEAR = new Date().getFullYear() + 10;

// Retention reset date bounds, unrelated to the timeframe schedule above.
export const RETENTION_MIN_YEAR = new Date().getFullYear();
export const RETENTION_MAX_YEAR = new Date().getFullYear() + 100;
